import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=17407358&scoped=true&"
import script from "./Credits.vue?vue&type=script&lang=js&"
export * from "./Credits.vue?vue&type=script&lang=js&"
import style0 from "./Credits.vue?vue&type=style&index=0&id=17407358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17407358",
  null
  
)

export default component.exports